package er.prateek.crossly.firebase

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.analytics.analytics
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.remoteconfig.remoteConfig

/**
 * Real values from the Firebase console's Web app (Project settings > General > Your apps >
 * Web app > SDK setup), for the production hosting domain.
 */
private val releaseWebAppOptions = FirebaseOptions(
    applicationId = "1:543175294082:web:6b73f3e9e8453a0f21889b",
    apiKey = "AIzaSyD7ASykDOMeG2K7Jr5vMHWn_GSU6FkY444",
    projectId = "croy-fdfaf",
    storageBucket = "croy-fdfaf.firebasestorage.app",
    gcmSenderId = "543175294082",
    authDomain = "croy-fdfaf.firebaseapp.com",
)

/**
 * Placeholder -- register a second Web app in the Firebase console (e.g. under a
 * `croy-b2745-debug` project, or a separate Web app entry in the same project) and swap
 * these values in, so local/staging traffic doesn't pollute production Analytics/Crashlytics.
 */
private val debugWebAppOptions = FirebaseOptions(
    apiKey= "AIzaSyDU1Z2laOf8eN8Yifjp_vXi0R_ueRUlvuw",
    authDomain= "croy-b2745.firebaseapp.com",
    projectId= "croy-b2745",
    storageBucket= "croy-b2745.firebasestorage.app",
    gcmSenderId = "1012096736805",
    applicationId = "1:1012096736805:web:d7ec0be0d85a8bfc9829cc",
//    measurementId= "G-C1VYB5LW6R"
)

/**
 * Kotlin/JS has no debug/release build-type split like Android -- webpack only knows
 * "development" vs "production" bundling, not a source config swap. Hostname is the simplest
 * runtime signal: swap in a real allowlist of prod domain(s) once one is registered.
 */
private fun isProdHost(): Boolean {
    val hostname: String = js("window.location.hostname")
    return hostname != "localhost" && hostname != "127.0.0.1"
}

private val webAppOptions: FirebaseOptions
    get() = if (isProdHost()) releaseWebAppOptions else debugWebAppOptions

private object JsAnalyticsLogger : AnalyticsLogger {
    override fun logEvent(name: String, params: Map<String, Any>) {
        Firebase.analytics.logEvent(name, params)
    }

    override fun setAnalyticsEnabled(enabled: Boolean) {
        Firebase.analytics.setAnalyticsCollectionEnabled(enabled)
    }
}

private object JsRemoteConfigClient : RemoteConfigClient {
    override suspend fun setDefaults() {
        Firebase.remoteConfig.setDefaults(
            RemoteConfigKeys.QUIZZES_ENABLED to RemoteConfigDefaults.QUIZZES_ENABLED,
            RemoteConfigKeys.HINTS_MAX_PER_PUZZLE to RemoteConfigDefaults.HINTS_MAX_PER_PUZZLE,
            RemoteConfigKeys.TIER_UNLOCK_THRESHOLD_PCT to RemoteConfigDefaults.TIER_UNLOCK_THRESHOLD_PCT,
            RemoteConfigKeys.APP_CONFIG to RemoteConfigDefaults.APP_CONFIG,
        )
    }

    override suspend fun fetchAndActivate(): Boolean = Firebase.remoteConfig.fetchAndActivate()
    override fun getBoolean(key: String): Boolean = Firebase.remoteConfig.getValue(key).asBoolean()
    override fun getLong(key: String): Long = Firebase.remoteConfig.getValue(key).asLong()
    override fun getString(key: String): String = Firebase.remoteConfig.getValue(key).asString()
}

actual object FirebaseProvider {
    init {
        // Unlike android/ios, JS has no ambient config file -- initialize() throws without
        // explicit FirebaseOptions, so the host-selected config above is required here.
        Firebase.initialize(options = webAppOptions)
    }

    actual val analytics: AnalyticsLogger = JsAnalyticsLogger

    // GitLive doesn't publish a JS target for firebase-crashlytics (no web equivalent
    // product regardless -- see docs/PLAN.md's "Platform caveat").
    actual val crashReporter: CrashReporter = NoOpCrashReporter
    actual val remoteConfig: RemoteConfigClient = JsRemoteConfigClient
}
